import React from "react";
import { SkeletonCard, SkeletonGrid } from "./Education.styles";

const EducationFeedSkeleton = () => (
  <SkeletonGrid aria-hidden="true">
    <SkeletonCard />
    <SkeletonCard />
    <SkeletonCard />
    <SkeletonCard />
  </SkeletonGrid>
);

export default EducationFeedSkeleton;
